var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0C4.032 0 0 4.032 0 9ZM16.812 9C16.812 13.32 13.32 16.812 9 16.812C4.68 16.812 1.188 13.32 1.188 9C1.188 4.68 4.68 1.188 9 1.188C13.32 1.224 16.812 4.716 16.812 9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47323 8.6758C5.32923 8.8918 5.32923 9.1798 5.47323 9.3958L7.84923 12.5638C8.02923 12.8158 8.42523 12.8878 8.67723 12.6718C8.82123 12.5638 8.92923 12.3838 8.92923 12.2038C8.92923 12.0958 8.89323 11.9518 8.82123 11.8438L7.16523 9.6118H12.2412C12.5652 9.6118 12.8532 9.3598 12.8532 8.9998C12.8532 8.6398 12.6012 8.3878 12.2412 8.3878H7.12923L8.78523 6.1558C8.96523 5.9038 8.92923 5.5078 8.64123 5.3278C8.38923 5.1478 7.99323 5.1838 7.81323 5.4718L5.47323 8.6758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5c0ac04cf478a55a975b8b53ed9fbdb1.svg";
export { ForwardRef as ReactComponent };